import { getParentStepIds } from '@shared/graph/getParentStepIds.js';

const getParentIterationStepIds = (stepId, steps, apps, graph) => {
  const parentSteps = getParentStepIds(stepId, graph);
  return parentSteps.filter((id) => {
    const step = steps.find((o) => o.id === id);
    const app = apps.find((o) => o.id === step?.appId);
    return app?.slug === 'iterate';
  });
};

export default getParentIterationStepIds;
